import type { JSX } from "react";
import { Icon, Link, Text, View } from "@/components";
import type { NormaLink } from "@/types/elearning/landing";

export interface NormativaListProps {
  items: NormaLink[];
}

/**
 * @name NormativaList
 * @description Lista de normas (leyes y decretos) de la landing pública. Cada
 * ítem enlaza a la norma en su fuente oficial (argentina.gob.ar/normativa) y
 * abre en pestaña nueva.
 *
 * @param {NormativaListProps} props - Las normas a renderizar.
 * @returns {JSX.Element} La lista de normas renderizada.
 */
const NormativaList = ({ items }: NormativaListProps): JSX.Element => (
  <View type="ul" className="flex flex-col gap-3">
    {items.map((norma) => (
      <View key={norma.url} type="li">
        <Link
          href={norma.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between gap-4 bg-card border border-border rounded-xl p-4 hover:border-navbar-border transition-colors"
        >
          <View className="flex flex-col gap-0.5">
            <Text type="span" className="font-medium text-foreground">
              {norma.name}
            </Text>
            {norma.description && (
              <Text type="span" className="text-sm text-muted-foreground">
                {norma.description}
              </Text>
            )}
          </View>
          <Icon
            name="arrow-up-right-from-square"
            className="text-(--sv-sky) shrink-0"
            aria-label="Se abre en una pestaña nueva"
          />
        </Link>
      </View>
    ))}
  </View>
);

export default NormativaList;
